module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_chapelsuns_02-80f3ba4020b217de85eec0523df59517.png";